export default __webpack_public_path__ + "static/media/Mobile-Internacional.c8a9f00e.svg";